<fieldset [ngClass]="props.fieldsetClass">
  @if (props.legend) {
  <legend [ngClass]="props.legendClass ? props.legendClass : 'sr-only'">{{ props.legend | translate }}</legend>
  }
  <div [ngClass]="props.childClass">
    @for (f of field.fieldGroup; track f) {
    <formly-field [field]="f" />
    }
  </div>
</fieldset>
